import React from 'react'
import List from '../../components/List'
import DashboardPage from '../../layouts/DashboardPage'

const columns = [
  { id: 'createdAt', disablePadding: true, label: 'Started' },
  { id: 'finishedAt', disablePadding: true, label: 'Finished' },
  { id: 'status', disablePadding: true, label: 'Status', kind: 'status' },
  { id: 'diff', disablePadding: true, label: 'Diff (hh:mm:ss)' },
  { id: 'researchId', disablePadding: true, label: 'Research ID' },
  { id: 'brandName', disablePadding: true, label: 'Brand Name' },
  { id: 'searchName', disablePadding: true, label: 'Search Name' },
  { id: 'cost', disablePadding: true, label: 'Cost' },
  { id: 'swUsedQuota', disablePadding: true, label: 'Used Quota' }
]

export default class Researches extends React.Component {
  render () {
    return (
      <DashboardPage
        kind="list"
        title="Researches"
        noActions
      >
        <List
          columns={columns}
          {...this.props}
          searchable
          emptyMessage={'No Researches matching the given criteria.'}
        />
      </DashboardPage>
    )
  }
}
